export default __webpack_public_path__ + "static/media/010_home.av1.dc9b7799.mp4";